import { z } from 'zod';

// Existing bounded C16 image identity, shared without a service/DOM dependency.
export const ImageId = z
  .string()
  .min(1)
  .max(160)
  .regex(/^[A-Za-z0-9_.:-]+$/u);
export const ImageFit = z.enum(['contain', 'cover']);
export const ImageRatio = z.enum(['intrinsic', '4:5', '3:4', '1:1', '16:9']);
export const MediaPublicReason = z.enum([
  'unsupported_format',
  'invalid_image',
  'too_large',
  'source_unavailable',
  'capture_not_admitted',
  'budget_exceeded',
  'policy_refused',
]);
export const ManagedImageSlot = z.discriminatedUnion('state', [
  z.strictObject({ state: z.literal('ready'), imageId: ImageId }),
  z.strictObject({ state: z.literal('capturing'), captureOperationRef: ImageId }),
  z.strictObject({ state: z.literal('missing') }),
  z.strictObject({ state: z.literal('refused'), reason: MediaPublicReason }),
]);
